import { Grid2, Modal } from "@mui/material";
import React from "react";
import TickImgModal from "assets/images/tickImgModal.png";
import CloseImgModal from "assets/images/closeImgModal.png";
import "./index.scss";
import { LoadingButton } from "@mui/lab";

const CustomModalSuccess = ({
  open,
  close,
  title = "",
  detail = "",
  resultStatus = true,
  loadingButton,
}) => {
  return (
    <Modal open={open} onClose={close} className="modal-box-container-succses">
      <Grid2
        className={`${
          detail
            ? "parent-content-modal-succses"
            : "parent-content-modal-succses empty-detail"
        }`}
        container
        columns={12}
        dir="rtl"
      >
        <Grid2 className="icon-tick" item size={{ xs: 6 }}>
          <img
            src={`${resultStatus ? TickImgModal : CloseImgModal}`}
            alt="Success Tick"
          />
        </Grid2>
        <Grid2
          className={`${
            detail ? "top-text transform-style" : "top-text title-empty-detail"
          }`}
          item
          size={{ xs: 11 }}
        >
          {title}
        </Grid2>
        {detail && (
          <Grid2 className="bottom-text" item size={{ xs: 11 }}>
            {detail}
          </Grid2>
        )}
        <Grid2 className="button-box" item size={{ xs: 11 }}>
          <LoadingButton
            loading={loadingButton}
            variant="contained"
            className="button-confirm-modal"
            onClick={() => {
              close();
            }}
            loadingPosition="end"
          >
            بازگشت
          </LoadingButton>
        </Grid2>
      </Grid2>
    </Modal>
  );
};

export default CustomModalSuccess;
